"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBMISSION_STATUSES = void 0;
var SUBMISSION_STATUSES = exports.SUBMISSION_STATUSES = {
  REVIEW: 'Review',
  APPROVAL: 'Approval',
  APPROVED: 'Approved',
  COMPLETED: 'Completed',
  REJECTED: 'Rejected'
};
Object.freeze(SUBMISSION_STATUSES);